import React, { useEffect, useState } from "react"
import Accordion from "@mui/material/Accordion"
import { styled } from "@mui/material/styles"
import {
  getAllDischargeSummary
} from "../../../../core/services/api"
import { getChemoOrderByAppointment, getMedicalRecordByAppointmentId } from "core/services/api"
import { getVitals } from "core/services/api/patientDiagnosisService"
import PrintDischargeSummary from "./PrintDischargeSummary"
import { PatientDetailStyles } from "resources/styles/pages/PatientDetailStyles"
import { useTheme } from "@emotion/react"
import { styles } from "resources/styles/Styles"
import moment from "moment"
import PrintDetailedDischargeSummary from "./PrintDetailedDischargeSummary"

const CustomAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: "#AFC4FF",
  borderBottom: 0,
}))

// @ts-ignore
function AllSummary({ patientInfo, readOnly, smartSummaryDetails, appointmentDate }: any) {
  const theme = useTheme()
  const globalStyles = styles(theme)
  const classes = PatientDetailStyles(theme)

  const [allOrders, setallOrders] = useState<any>([])
  const [selectedOrder, setSelectedOrder] = useState<any>({})
  const [vitalsData, setVitalsData] = useState<any>({})
  const [smartSummaryData, setSmartSummaryData] = useState<any>()
  const [chemoData, setChemoData] = useState<any>()
  const [accordion, updateAccordion] = React.useState<any | null>()
  const [appointmentDischargeId, setAppointmentDischargeId] = useState<any>()


  useEffect(() => {
    getAllDischargeSummary(patientInfo?.id)
      .then((res) => {
        res?.sort((a: any, b: any) => new Date(b?.dateOfDischarge)?.getTime() - new Date(a?.dateOfDischarge)?.getTime());
        setallOrders(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }, [])

  useEffect(() => {
    if (smartSummaryDetails) {
      setSmartSummaryData(smartSummaryDetails)
    }
  }, [smartSummaryDetails])

  useEffect(() => {
    if (selectedOrder?.appointmentId) {
      getMedicalRecordByAppointmentId(selectedOrder?.appointmentId)
        .then((response: any) => {
          const recordId = response?.id
          setAppointmentDischargeId(response?.appointmentId)
          if (recordId) {
            getVitals(recordId, true)
              .then((data: any) => {
                const res = data.data
                setVitalsData(res)
              })
              .catch((err: any) => {
                console.log(err)
              })
          }
        })
        .catch((err: any) => {
          console.log("error in fetching record", err)
        })

      getChemoOrderByAppointment(selectedOrder?.appointmentId)
        .then((response: any) => {
          setChemoData(response)
        })
        .catch((err: any) => {
          console.log("error in fetching record", err)
        })
    }
  }, [selectedOrder])

  function handleChange(panel: any) {
    updateAccordion(panel !== accordion ? panel : false)
    if (panel !== accordion && allOrders && allOrders[panel]) {
      setSelectedOrder(allOrders[panel])
    }
  }

  function renderAccordion(
    eachSummary: any,
    index: number
  ) {
    return (
      <>
        <div className={classes.accordionDischargeSummary}>
          <div className={`col-md-12 row p-0 m-0`}>
            <div className={`col-md-12 p-0`}>
              <div className={`${classes.accordionHeaderSpacing} d-flex`}>
                <div className="col-md-3 p-0">
                  <div className={classes.appContentTitleDischargeSummary}>Discharge Summary</div>
                </div>
                <div className="col-md-2 p-0">
                  <div className={classes.appContentTitleDischargeSummary}>
                    {eachSummary?.cycleNo ? `${eachSummary?.cycleNo} Cycle`
                      : "-"}
                  </div>
                </div>
                <div className="col-md-3 p-0">
                  <div className={classes.appContentTitleDischargeSummary}>
                    {eachSummary?.regimen ? eachSummary?.regimen
                      : "-"}
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className={classes.appContentTitleDischargeSummary}>
                    {eachSummary?.dateOfDischarge
                      ? moment(eachSummary?.dateOfDischarge).format('DD-MM-YYYY')
                      : "-"}
                  </div>
                </div>
                <div className="col-md-2 p-0">
                  <div className={`${classes.pl30DischargeSummary}`}>
                    <img
                      className={globalStyles.pointer}
                      src={
                        accordion === index
                          ? "../../../assets/images/chevronUpIcon.svg"
                          : "../../../assets/images/chevronDownIcon.svg"
                      }
                      alt={accordion === index ? "upArrow" : "downArrow"}
                      onClick={() => handleChange(index)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {accordion === index && (
          <div className={`${classes.accordionContentDischargeSummary}`}>
            {eachSummary?.viewType === "DETAILED" ? (
              <PrintDetailedDischargeSummary
                patient={patientInfo}
                vitalsData={vitalsData}
                smartSummaryData={smartSummaryData}
                chemoData={chemoData}
                selectedOrder={selectedOrder}
                appointmentDischargeId={appointmentDischargeId}
                appointmentDate={appointmentDate}
              />
            ) : (
              <PrintDischargeSummary
                patient={patientInfo}
                vitalsData={vitalsData}
                smartSummaryData={smartSummaryData}
                chemoData={chemoData}
                selectedOrder={selectedOrder}
                appointmentDate={appointmentDate}
              />
            )}
          </div>
        )}
      </>
    )
  }

  return (
    <div>
      {allOrders && allOrders?.length > 0 ? (
        allOrders?.map((each: any, index: any) =>
          renderAccordion(each, index)
        )
      ) : (
        <div className={`${classes.noDataState}`}>
          No data available.
        </div>
      )}
    </div>
  )
}

export default AllSummary